export interface ResearchMessage {
  role: 'user' | 'assistant';
  content: string;
  sources?: { title: string; uri: string }[];
}

export const performProbateResearch = async (
  query: string,
  history: ResearchMessage[] = [],
  estateContext?: string,
  tier: 'free' | 'paid' = 'free',
) => {
  const response = await fetch('/api/research', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, history, estateContext, tier })
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Server Error: ${response.status}`);
  }

  return response.json();
};
